var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1"},React.createElement("g",{"transform":"translate(-273.000000, -20.000000)"},React.createElement("g",null,React.createElement("g",{"transform":"translate(273.000000, 20.000000)"},[React.createElement("rect",{"x":"0","y":"0","width":"30","height":"2.88","key":0}),React.createElement("rect",{"x":"0","y":"7.2","width":"30","height":"2.88","key":1}),React.createElement("rect",{"x":"0","y":"15.12","width":"30","height":"2.88","key":2})])))));
}

Hamburger.defaultProps = {"width":"30px","height":"18px","viewBox":"0 0 30 18","version":"1.1"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
